import { supabase, applyOrgFilter } from '../supabaseClient'

export async function getEstadisticasTorneo(torneoId) {
  let query = supabase
    .from('juegos')
    .select('puntos_favor, puntos_contra, resultado, estatus, grupo_id')
    .eq('torneo_id', torneoId)
    .eq('activo', true)
    .is('deleted_at', null);

  query = applyOrgFilter(query);

  const { data: juegos, error } = await query;

  if (error) {
    console.error('[getEstadisticasTorneo] Error:', error);
    throw error;
  }

  // Calculate statistics
  const terminados = juegos.filter(j => j.estatus === 'terminado');
  const stats = {
    total_juegos: juegos.length,
    terminados: terminados.length,
    programados: juegos.filter(j => j.estatus === 'programado').length,
    en_curso: juegos.filter(j => j.estatus === 'en_curso').length,
    victorias: terminados.filter(j => j.resultado === 'W').length,
    derrotas: terminados.filter(j => j.resultado === 'L').length,
    empates: terminados.filter(j => j.resultado === 'D').length,
    puntos_favor: terminados.reduce((sum, j) => sum + (j.puntos_favor || 0), 0),
    puntos_contra: terminados.reduce((sum, j) => sum + (j.puntos_contra || 0), 0),
    grupos_participantes: new Set(juegos.map(j => j.grupo_id)).size
  };

  // Calculate win percentage
  if (terminados.length > 0) {
    stats.porcentaje_victoria = ((stats.victorias / terminados.length) * 100).toFixed(1);
  } else {
    stats.porcentaje_victoria = 0;
  }

  return stats;
}

export async function getEstadisticasGrupoEnTorneo(torneoId, grupoId) {
  let query = supabase
    .from('juegos')
    .select('*')
    .eq('torneo_id', torneoId)
    .eq('grupo_id', grupoId)
    .eq('activo', true)
    .is('deleted_at', null);

  query = applyOrgFilter(query);

  const { data: juegos, error } = await query;

  if (error) {
    console.error('[getEstadisticasGrupoEnTorneo] Error:', error);
    throw error;
  }

  const terminados = juegos.filter(j => j.estatus === 'terminado');
  const stats = {
    total_juegos: juegos.length,
    terminados: terminados.length,
    victorias: terminados.filter(j => j.resultado === 'W').length,
    derrotas: terminados.filter(j => j.resultado === 'L').length,
    empates: terminados.filter(j => j.resultado === 'D').length,
    puntos_favor: terminados.reduce((sum, j) => sum + (j.puntos_favor || 0), 0),
    puntos_contra: terminados.reduce((sum, j) => sum + (j.puntos_contra || 0), 0),
    diferencia_puntos: 0
  };

  stats.diferencia_puntos = stats.puntos_favor - stats.puntos_contra;

  if (terminados.length > 0) {
    stats.porcentaje_victoria = ((stats.victorias / terminados.length) * 100).toFixed(1);
  } else {
    stats.porcentaje_victoria = 0;
  }

  return stats;
}

export async function getAsistenciaGrupoEnTorneo(torneoId, grupoId) {
  let query = supabase
    .from('asistencias')
    .select('presente, juego:juegos(id, torneo_id, estatus)')
    .eq('grupo_id', grupoId)
    .eq('activa', true)
    .not('juego_id', 'is', null)
    .eq('juego.torneo_id', torneoId);

  query = applyOrgFilter(query);

  const { data: asistencias, error } = await query;

  if (error) {
    console.error('[getAsistenciaGrupoEnTorneo] Error:', error);
    throw error;
  }

  let total = 0;
  let presentes = 0;

  (asistencias || []).forEach((row) => {
    const valor = row.presente;
    if (valor === null || valor === undefined || valor === 'exento') return;
    total += 1;
    if (valor === true || valor === 'presente' || valor === 'retardo') {
      presentes += 1;
    }
  });

  const porcentaje = total > 0 ? Math.round((presentes / total) * 100) : 0;

  return {
    total,
    presentes,
    porcentaje
  };
}

export async function getHistorialVsEquipo(equipoId, grupoId = null) {
  let query = supabase
    .from('juegos')
    .select(`
      *,
      grupo:grupos(id, nombre_del_grupo),
      torneo:torneos(id, nombre, temporada_id)
    `)
    .eq('equipo_id', equipoId)
    .eq('activo', true)
    .is('deleted_at', null)
    .eq('estatus', 'terminado')
    .order('fecha', { ascending: false });

  if (grupoId) {
    query = query.eq('grupo_id', grupoId);
  }

  query = applyOrgFilter(query);

  const { data, error } = await query;

  if (error) {
    console.error('[getHistorialVsEquipo] Error:', error);
    throw error;
  }

  return data;
}
